import Service from 'vuex-service-api';
import ServiceGo from 'vuex-service-go-api';

export const service = new Service({
  baseURL: process.env.API_HOST,
  tocken: process.env.API_TOCKEN,
});
export const service_Go = new ServiceGo({
  baseURLGo: process.env.API_HOST_GO,
  tocken: process.env.API_TOCKEN_Go,
});



// WEBPACK FOOTER //
// ./src/service/index.js